import mixitup from 'mixitup';
import mixitupMultifilter from './mixitup-multifilter.min';
import mixitupPagination from './mixitup-pagination.min';

mixitup.use(mixitupMultifilter);
mixitup.use(mixitupPagination);

jQuery(document).ready(function ($) {
const el = $('.post-cards');

    if (el.length > 0) {
        let mixer = mixitup('.post-cards', {
            multifilter: {
                enable: true
            },
            selectors: {
                target: '.mix'
            },
            animation: {
                duration: 500
            }
        });
    }
});

jQuery(document).ready(function ($) {
    const el = $('.post-cards-pagination');
    if (el.length > 0) {
        let paginationMixer = mixitup('.post-cards-pagination', {
            multifilter: {
                enable: true
            },
            selectors: {
                target: '.mix'
            },
            pagination: {
                limit: 8,
                maintainActivePage: false,
                hidePageListIfSinglePage: true
            },
            templates : {
                pager: '<div class="${classNames}" data-page="${pageNumber}" data-mixitup-control>${pageNumber}</div>',
                pagerPrev: '<div class="${classNames}" data-page="prev" data-mixitup-control>'+el.attr('data-previous')+'</div>',
                pagerNext: '<div class="${classNames}" data-page="next" data-mixitup-control>'+el.attr('data-next')+'</div>'
            },
            animation: {
                duration: 500
            }
        });
    }
});
